import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { AppComponent } from './app/app.component';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { enableProdMode, isDevMode, LOCALE_ID } from '@angular/core';
import { APP_ROUTES } from './app/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { errorCatchingInterceptor } from './app/core/interceptors/error-catching.interceptor';
import { loadingInterceptor } from './app/core/interceptors/loading.interceptor';
import { tenantInterceptor } from './app/core/interceptors/tenant.interceptor';
import { romeoStoreProviders } from './app/core/store/romeo.store.provider';
import { reducers } from './app/core/store/reducers';
import { IamModule, OPTIONS } from '@fullstackagency/iam';
import { environment } from './environments/environment';
import { importProvidersFrom } from '@angular/core';
import { ApiModule } from '@generated/api.module';
import { register } from 'swiper/element/bundle';
import { ToastService } from './app/core/ui/toast/toast.service';

register();
registerLocaleData(localeIt);

if (environment.production) {
  enableProdMode();
}

interface TusConfiguration {
  'tus.endpoint': string;
}
export class Configuration implements TusConfiguration {
  'tus.endpoint': string;

  constructor(source: TusConfiguration) {
    Object.assign(this, source);
  }
}

async function bootstrap() {
  const response = await fetch('/api/public/configuration');
  const payload = await response.json();

  await bootstrapApplication(AppComponent, {
    providers: [
      provideIonicAngular(),

      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

      provideRouter(APP_ROUTES, withPreloading(PreloadAllModules)),

      provideHttpClient(
        withInterceptors([
          errorCatchingInterceptor,
          loadingInterceptor,
          tenantInterceptor,
        ])
      ),

      provideStore(reducers),
      ...romeoStoreProviders,
      provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),

      { provide: LOCALE_ID, useValue: 'it-IT' },
      {
        provide: Configuration,
        useValue: new Configuration(payload),
      },
      importProvidersFrom(IamModule),
      importProvidersFrom(ApiModule.forRoot({ rootUrl: '/api' })),
      {
        provide: OPTIONS,
        useValue: {
          client: {
            basePath: environment['iam.basePath'],
          },
          paths: {
            error: '/error',
            index: '/',
            login: '/account/login',
            recovery: '/account/password-recovery',
            registration: '/account/sign-up',
            settings: '/settings',
            verification: '/account/verification',
          },
        },
      },
      ToastService,
    ],
  });
}

bootstrap();
